import React, {Component} from 'react';
import {connect} from 'react-redux';

import * as spActions from '../../actions/sp';
import {SUBMIT_STATUS} from '../../reducers/sp';
import AppNames from "../AppNames/AppNames";
import '../index.scss';
import {checkSession} from "../../api/api";
import * as messageConstants from '../../shared/messages';
import Message from "../Message";
import LaunchError from "../LaunchError";
import {FIXED_OIDC_SCOPE} from "../../constants/oidcConstants";
import RedirectUris from "./RedirectUris/RedirectUris";
import ClientCredentials from "./ClientCredentials/ClientCredentials";
import PublicClient from './PublicClient/PublicClient';

const enteredRedirectUris = (oidcRedirectUris) => oidcRedirectUris.filter(uri => uri.redirectUri.length > 0);

export class OidcApp extends Component {
  handleSaveSP = () => {
    const uris = enteredRedirectUris(this.props.oidcRedirectUris).map(uri => uri.redirectUri);
    if (uris.some((uri, index) => uris.indexOf(uri) !== index)) {
      this.props.setErrorMessage(messageConstants.OIDC_URI_IS_DUPLICATED);
    } else {
      this.props.addApp();
    }
  }

  handleChangeAppName = (e) => {
    this.props.updateAppName(e.target.value);
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      this.props.generateOidcClientCredentials();
    }
  }

  render() {
    const {
      applicationName, nameErrorMsg, oidcRedirectUris, clientId, clientSecret, isPublicClient, submitStatus,
      credentialsInProgress, errorMsg, launchError, clearMessages, addOidcRedirectUri, deleteOidcRedirectUri,
      updateOidcRedirectUri, updateIsPublicClient, generateOidcClientCredentials, cancelAddApp
    } = this.props;
    if (launchError) {
      return <LaunchError/>;
    }
    const isSubmitting = submitStatus !== SUBMIT_STATUS.IDLE;
    return (
        <div className="AddApp-container">
          <div className="container">
            <Message errorMessage={errorMsg}
                     clearMessages={clearMessages}/>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12">
                <div className="add-edit-title">{messageConstants.OIDC_TITLE_ADD}</div>
                <div className="add-edit-subtitle">
                  {messageConstants.OIDC_SUBTITLE}
                </div>

                <AppNames applicationName={applicationName}
                          errorMessage={nameErrorMsg}
                          handleChangeAppName={this.handleChangeAppName}/>

                <RedirectUris
                  oidcRedirectUris={oidcRedirectUris}
                  handleAddOidcRedirectUri={addOidcRedirectUri}
                  handleDelOidcRedirectUri={deleteOidcRedirectUri}
                  handleUpdateOidcRedirectUri={updateOidcRedirectUri}/>

                &nbsp;
                <ClientCredentials
                  clientId={clientId}
                  clientSecret={clientSecret}
                  inProgress={credentialsInProgress}
                  generateOidcClientCredentials={generateOidcClientCredentials}/>

                <PublicClient
                  isPublicClient={isPublicClient}
                  updateIsPublicClient={updateIsPublicClient}
                />

                <p className="sba-subtitle">{messageConstants.OIDC_SCOPES_TITLE}</p>
                <div className="add-edit-subtitle" id="oidcScopeValue">{FIXED_OIDC_SCOPE}</div>

                <div className="action-row">
                  <button
                    id="cancelSaveOidcApplicationButton"
                    type="button"
                    className="btn btn-md cancel-save-button"
                    onClick={cancelAddApp}
                  >
                    {messageConstants.CANCEL}
                  </button>
                  &nbsp;
                  <button
                    id="saveOidcApplicationButton"
                    type="button"
                    className="btn btn-md btn-primary save-button"
                    disabled={isSubmitting || credentialsInProgress || !applicationName.trim() || !clientId
                      || enteredRedirectUris(oidcRedirectUris).length === 0}
                    onClick={this.handleSaveSP}
                  >
                    {messageConstants.SBA_SAVE_BUTTON}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    launchError: state.auth.launchError,
    errorMsg: state.sp.errorMsg,
    nameErrorMsg: state.sp.nameErrorMsg,
    submitStatus: state.sp.submitStatus,
    credentialsInProgress: state.sp.credentialsInProgress,
    oidcRedirectUris: state.sp.oidcRedirectUris,
    clientId: state.sp.clientId,
    clientSecret: state.sp.clientSecret,
    isPublicClient: state.sp.isPublicClient,
    applicationName: state.sp.applicationName,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAppName: (name) => {
      dispatch(spActions.updateAppName(name))
    },
    addApp: () => {
      dispatch(spActions.addOidc());
    },
    cancelAddApp: () => {
      dispatch(spActions.cancelAddApp());
    },
    addOidcRedirectUri: () => {
      dispatch(spActions.addOidcRedirectUri());
    },
    deleteOidcRedirectUri: (redirectUri) => {
      dispatch(spActions.deleteOidcRedirectUri(redirectUri));
    },
    updateOidcRedirectUri: (evt) => {
      dispatch(spActions.updateOidcRedirectUri(evt));
    },
    clearMessages: () => {
      dispatch(spActions.clearMessages())
    },
    setErrorMessage: (errorMessage) => {
      dispatch(spActions.setErrorMessage(errorMessage))
    },
    generateOidcClientCredentials: () => {
      dispatch(spActions.generateOidcClientCredentials());
    },
    updateIsPublicClient: (value) => {
      dispatch(spActions.updateIsPublicClient(value));
    }
  }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OidcApp);
